import { render } from "./FeedbackHistoryView.vue?vue&type=template&id=63bdc940&scoped=true"
import script from "./FeedbackHistoryView.vue?vue&type=script&lang=js"
export * from "./FeedbackHistoryView.vue?vue&type=script&lang=js"

import "./FeedbackHistoryView.vue?vue&type=style&index=0&id=63bdc940&scoped=true&lang=css"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63bdc940"]])

export default __exports__